module.exports = "https://cdn.dashboard.gifty.nl/5688/images/truck.svg?283e2106a707df2f4104a49e1c650408";